module.exports = __webpack_public_path__ + "d2a86793dba21b0bfb9858dc89f2fca9.MP3";